<div class="wizard-detection-method">
    <div class="detection-subtitle">{{ 'ADD_CAMERA_WIZARD.DETECTION.SUBTITLE'|translate }}</div>

    <form [formGroup]="detectionForm" class="detection-form">
        <!-- Express (Recommended) -->
        <div class="detection-option">
            <input type="radio" id="express" [value]="DetectionMethod.Express" formControlName="method">
            <label for="express" class="option-content">
                <div class="option-header">
                    <span class="option-title">{{ 'ADD_CAMERA_WIZARD.DETECTION.EXPRESS.TITLE'|translate }}</span>
                </div>
                <div class="option-description">
                    {{ 'ADD_CAMERA_WIZARD.DETECTION.EXPRESS.DESCRIPTION'|translate }}
                </div>
            </label>
        </div>

        <!-- Address Range Scanning -->
        <div class="detection-option">
            <input type="radio" id="addressRange" [value]="DetectionMethod.AddressRange" formControlName="method">
            <label for="addressRange" class="option-content">
                <div class="option-header">
                    <span class="option-title">{{ 'ADD_CAMERA_WIZARD.DETECTION.ADDRESS_RANGE.TITLE'|translate }}</span>
                </div>
                <div class="option-description">
                    {{ 'ADD_CAMERA_WIZARD.DETECTION.ADDRESS_RANGE.DESCRIPTION'|translate }}
                </div>
            </label>
        </div>

        <!-- Address Range Inputs (conditional) -->
        <div class="address-range-inputs" *ngIf="showAddressRangeInputs">
            <div class="input-row">
                <div class="input-group">
                    <label for="ipStart">{{ 'ADD_CAMERA_WIZARD.DETECTION.ADDRESS_RANGE.START_IP'|translate }}</label>
                    <input type="text" id="ipStart" class="ui-input ui-input-40" formControlName="ipStart"
                        [placeholder]="'ADD_CAMERA_WIZARD.DETECTION.ADDRESS_RANGE.START_IP_PLACEHOLDER'|translate">
                </div>
                <div class="input-group">
                    <label for="ipEnd">{{ 'ADD_CAMERA_WIZARD.DETECTION.ADDRESS_RANGE.END_IP'|translate }}</label>
                    <input type="text" id="ipEnd" class="ui-input ui-input-40" formControlName="ipEnd"
                        [placeholder]="'ADD_CAMERA_WIZARD.DETECTION.ADDRESS_RANGE.END_IP_PLACEHOLDER'|translate">
                </div>
                <div class="input-group">
                    <label for="port">{{ 'ADD_CAMERA_WIZARD.DETECTION.ADDRESS_RANGE.PORT'|translate }}</label>
                    <input type="number" id="port" class="ui-input ui-input-40" formControlName="port"
                        [placeholder]="'ADD_CAMERA_WIZARD.DETECTION.ADDRESS_RANGE.PORT_PLACEHOLDER'|translate">
                </div>
            </div>
        </div>

        <!-- ONVIF Search -->
        <div class="detection-option">
            <input type="radio" id="onvifSearch" [value]="DetectionMethod.OnvifSearch" formControlName="method">
            <label for="onvifSearch" class="option-content">
                <div class="option-header">
                    <span class="option-title">{{ 'ADD_CAMERA_WIZARD.DETECTION.ONVIF.TITLE'|translate }}</span>
                </div>
                <div class="option-description">
                    {{ 'ADD_CAMERA_WIZARD.DETECTION.ONVIF.DESCRIPTION'|translate }}
                </div>
            </label>
        </div>

        <!-- Manual -->
        <div class="detection-option">
            <input type="radio" id="manual" [value]="DetectionMethod.Manual" formControlName="method">
            <label for="manual" class="option-content">
                <div class="option-header">
                    <span class="option-title">{{ 'ADD_CAMERA_WIZARD.DETECTION.MANUAL.TITLE'|translate }}</span>
                </div>
                <div class="option-description">
                    {{ 'ADD_CAMERA_WIZARD.DETECTION.MANUAL.DESCRIPTION'|translate }}
                </div>
            </label>
        </div>

        <!-- Import from CSV -->
        <div class="detection-option">
            <input type="radio" id="csvImport" [value]="DetectionMethod.CsvImport" formControlName="method">
            <label for="csvImport" class="option-content">
                <div class="option-header">
                    <span class="option-title">{{ 'ADD_CAMERA_WIZARD.DETECTION.CSV_IMPORT.TITLE'|translate }}</span>
                </div>
                <div class="option-description">
                    {{ 'ADD_CAMERA_WIZARD.DETECTION.CSV_IMPORT.DESCRIPTION'|translate }}
                </div>
            </label>
        </div>
    </form>


</div>